import React from 'react';
import {
  newGuid, flattenObject, mergeError, triageErrors
} from './helpers';

interface OwnProps {
  onChange?: (event: any) => void
  onFocus?: (event: any) => void
  onValidate?: (event: any) => void
  onKeyDown?: (event: any) => void
  onBlur?: (event: any) => void

  // These are disabled as it conflicts with 4733 types.
  // id?: string;
  // name?: string;
  // value?: string;
  // checked?: boolean;
}

/** When using ValidationElement, you'll want to extend off of these props. */
export type ValidationElementProps = OwnProps

export default class ValidationElement<
  P extends ValidationElementProps = {},
  S = {}
> extends React.Component<P, S> {
  constructor(props) {
    super(props);

    // As this is inherited, these functions need to stay as functions (instead
    // of arrow functions). Swapping to Arrow Functions will break
    // functionality.
    this.handleChange = this.handleChange.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleValidation = this.handleValidation.bind(this);
    this.guid = this.guid.bind(this);
    this.mergeError = this.mergeError.bind(this);
    this.flattenObject = this.flattenObject.bind(this);
    this.triageErrors = this.triageErrors.bind(this);
  }

  componentDidMount() {
    const event = {
      target: {
        id: this.props.id || '',
        name: this.props.name,
        value: this.props.value,
        checked: this.props.checked,
      },
      persist() {},
      fake: true,
    };

    this.handleValidation(event);
  }

  /**
   * Handle the change event.
   */
  handleChange(event) {
    if (this.props.onChange) {
      this.props.onChange(event);
    }
  }

  /**
   * Handle the focus event.
   */
  handleFocus(event) {
    if (this.props.onFocus) {
      this.props.onFocus(event);
    }
  }

  /**
   * Handle the blur event.
   */
  handleBlur(event) {
    this.handleValidation(event);
    if (this.props.onBlur) {
      this.props.onBlur(event);
    }
  }

  /**
   * Handle the validation event.
   */
  handleValidation(event) {
    if (this.props.onValidate) {
      this.props.onValidate(event);
    }
  }

  /**
   * Handle the key down event.
   */
  handleKeyDown(event) {
    if (this.props.onKeyDown) {
      this.props.onKeyDown(event);
    }
  }

  flattenObject(obj) {
    return flattenObject(obj);
  }

  mergeError(previous, error) {
    return mergeError(previous, error);
  }

  triageErrors(section, previous, codes) {
    return triageErrors(section, previous, codes);
  }

  guid() {
    return newGuid();
  }
}
